<template>
      <div>
            <!-- Headline -->
            <div class="flex xs-12 xs-between">
                  <div class="fs5 lh125 fw7 c1 mb2">{{ $t("benefit_options") }}</div>
            </div>

            <!-- Body -->
            <j-card class="bg5" v-if="computedBenefitOptions.length > 0">
                  <j-list :list="computedBenefitOptions">
                        <div class="flex-wrap xs-12 p3" slot="list" slot-scope="{ item }">
                              <div class="flex xs-12 xs-left xs-middle fw7 c6">{{ item.label }}</div>
                              <div class="flex xs-12 xs-left xs-middle mt2">
                                    <span>{{ item.value }}</span>
                              </div>
                        </div>
                  </j-list>
            </j-card>
            
            <!-- Empty -->
            <j-card class="bg5" v-else>
                  <div class="xs-12 p2 ta2 fs3">{{ $t("errors.no_data") }}</div>
            </j-card>
      </div>
</template>

<script>
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import get from "lodash.get"
import dayjs from "dayjs"
import { firstLetterUppercase, unCamelCase } from "@/utils/"

export default {
	components: {
		JCard,
		JList
	},

	props: {
		list: {
			type: Array
		}
  },
  
  methods: {
    getNonNullScalarValue(scalarObject) {
      const output =  Object.entries(scalarObject)
      .filter(([key,value])=>{
        return value !==null
      })
      .map(([key,value])=>{
        return { key,value }
      })
      return output[0].value
    }
  },

	computed: {
		computedBenefitOptions() {
      let benefitOptionValue

      if(this.list)

      return this.list.map(benefitOption => {
        if (benefitOption.formattedValue) {
          benefitOptionValue = benefitOption.formattedValue
        }
        else {
          benefitOptionValue = this.getNonNullScalarValue(benefitOption.value)
        }

        return {
          label: benefitOption.name,
          value: benefitOptionValue
        }
      })

      else return []
    }
	}
}
</script>
